var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChild = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 16 17"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#404347",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.5 10.5a.5.5 0 0 1 .5.5 2 2 0 1 1-4 0 .5.5 0 0 1 1 0 1 1 0 1 0 2 0 .5.5 0 0 1 .5-.5M11.5 8.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8 .5C4.916.5 3.204 2.06 2.288 3.622a8.2 8.2 0 0 0-1 2.803l-.028.216a2 2 0 0 0-.067 3.69C1.931 13.296 4.698 15.5 8 15.5s6.07-2.204 6.807-5.17a2 2 0 0 0 .16-3.582l-.02-.1a9.072 9.072 0 0 0-1.113-2.906C12.861 2.13 11.091.5 8 .5M1.862 7.51q.137-.018.287-.075c.929.322 1.77.472 2.527.498a1 1 0 1 0 1.542-.128 5.8 5.8 0 0 0 1.719-.653 5.9 5.9 0 0 0 1.547-1.285c.232.297.562.663.99.996.893.695 2.219 1.242 3.902.71A1 1 0 0 1 15 8.5c0 .393-.268.84-.668.943q-.006.004-.072.015a3 3 0 0 1-.31.035q-.064.464-.2.901C13.015 12.752 10.741 14.5 8 14.5s-5.015-1.748-5.75-4.106a5.5 5.5 0 0 1-.2-.894H2q-.033 0-.065-.002a1 1 0 0 1-.073-1.989m.44-1.082c2.415.887 4.077.466 5.136-.143a5 5 0 0 0 1.248-1.024 4 4 0 0 0 .295-.377l.006-.01c.13-.187.26-.376.518-.374.197.002.353.12.448.286l.052.086a4.772 4.772 0 0 0 1.083 1.203c.673.522 1.613.924 2.841.587a8.069 8.069 0 0 0-.951-2.404C12.14 2.87 10.66 1.5 8 1.5c-2.666 0-4.079 1.315-4.85 2.628a7.2 7.2 0 0 0-.847 2.3",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h16v16H0z"
})))));
export default SvgChild;